/**
 *    @author:
 *    @since:
 *
 */

import { IValidator } from '../_common/component/IValidator';
import { BeforeYouBeginComponent} from './before_you_begin.component';

export class BeforeYouBeginValidation extends IValidator {

       constructor(private component: BeforeYouBeginComponent) {
             super();
       }

       private success: boolean;

       public validate(): boolean {

            this.success = true;

            // add your valdation here!

            return this.success;

       }
}

